import { render, staticRenderFns } from "./standart-modal-header.vue?vue&type=template&id=aa49a288&"
import script from "./standart-modal-header.vue?vue&type=script&lang=ts&"
export * from "./standart-modal-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports